import { render, staticRenderFns } from "./DatatableTableElement.vue?vue&type=template&id=b6735e12&scoped=true&"
import script from "./DatatableTableElement.vue?vue&type=script&lang=js&"
export * from "./DatatableTableElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6735e12",
  null
  
)

export default component.exports